import { IS_ADWILE } from "../constants/cabinet";
import { getCabinetType } from "../../customers/config/api";

/* eslint import/prefer-default-export: 0, arrow-parens: 0 */
export const dashUrls = {
  campaignStat: cid => `/campaigns/${cid}/stat/common/`,
  campaignUpdate: cid => `/campaigns/${cid}/update/`
};

export const appUrls = {
  login: "/user/login/",
  register: "/user/register/",
  passwordReset: "/user/password/reset/",

  agreement: "/help/agreement/",
  rules: "/help/rules/",
  privacy: "/help/privacy/",
  offer: "/help/offer/",

  exchangeSection: "/exchange/",
  exchangeRules: "/help/exchange/rules/",
  exchangeFaq: "/help/exchange/faq/",

  advertSection: "/advert/",
  advertRules: "/help/advert/rules/",
  advertFaq: "/help/advert/faq/",
  advertGoods: "/help/advert/goods/",
  advertOffer: "/help/offer/advert",

  webmasterSection: "/webmaster/",
  webmasterRules: "/help/webmaster/rules/",
  webmasterFaq: "/help/webmaster/faq/",
  webmasterOffer: "/help/offer/webmaster",

  help: "https://help.adwile.com/"
};

export function getOfferPath() {
  return IS_ADWILE ? `${getCabinetType()}Offer` : "offer";
}
